import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('personId').setType(Number);
schema.prop('specialisationId').setType(Number);

export default schema;
